export default {
  
};

const apiSettings = {
  url : "https:///api.sistemasmg.app/api/",
  gallery : "http://api.sistemasmg.app",
  //url : "https://api.wizzarn.com/api/",
  //url : "http://pension.test/api/",
  //gallery : "http://pension.test",
}

const notificationTimer = {
  value: 60000
}
const tankLitresTimer = {
  value: 30000
}
const dashboardTimer = {
  value: 90000
}
const siteConfig = {
  siteName: 'SMG',
  siteIcon: 'ion-flash',
  footerText: 'Sistema de Pensiones',
  production: true
};

const themeConfig = {
  topbar: 'themedefault',
  sidebar: 'themedefault',
  layout: 'themedefault',
  theme: 'themedefault'
};
const language = 'spanish';
const AlgoliaSearchConfig = {
  appId: '',
  apiKey: ''
};
const Auth0Config = {
  domain: '',
  clientID: '',
  allowedConnections: ['Username-Password-Authentication'],
  rememberLastLogin: true,
  language: 'es',
  closable: true,
  options: {
    auth: {
      autoParseHash: true,
      redirect: true,
      redirectUrl: 'http://localhost:3000/auth0loginCallback'
    },
    languageDictionary: {
      title: 'SMG',
      emailInputPlaceholder: 'demo@gmail.com',
      passwordInputPlaceholder: 'demodemo'
    },
    theme: {
      labeledSubmitButton: true,
      logo: '',
      primaryColor: '#E14615',
      authButtons: {
        connectionName: {
          displayName: 'Log In',
          primaryColor: '#b7b7b7',
          foregroundColor: '#000000'
        }
      }
    }
  }
};
const firebaseConfig = {
  apiKey: '',
  authDomain: '',
  databaseURL: '',
  projectId: '',
  storageBucket: '',
  messagingSenderId: ''
};
const googleConfig = {
  apiKey: '' //
};
const mapboxConfig = {
  tileLayer: '',
  maxZoom: '',
  defaultZoom: '',
  center: []
};
const youtubeSearchApi = '';
export {
  siteConfig,
  themeConfig,
  dashboardTimer,
  language,
  AlgoliaSearchConfig,
  Auth0Config,
  firebaseConfig,
  googleConfig,
  mapboxConfig,
  apiSettings,
  youtubeSearchApi,
  notificationTimer,
  tankLitresTimer
};
